import { Variant } from "~/@types/product";
import type { Option } from '~/components/Abstracts/Form/Select'

function variantsToOptions(variants: Variant[]): Option[] {
  return (
    variants?.map(({ title, price }) => ({
      value: title,
      label: `${title?.toUpperCase()} ― ${price?.toUpperCase()}`,
    })) ?? []
  )
}

export default variantsToOptions
